import { ChakraProvider } from "@chakra-ui/react";
import { type PropsWithChildren, useEffect } from "react";

import { theme } from "@/app/theme";
import { I18nProvider } from "@/i18n";
import { initializeFirebaseAnalytics } from "@/shared/firebase/client";

export function AppProviders({ children }: PropsWithChildren) {
  useEffect(() => {
    void initializeFirebaseAnalytics();
  }, []);

  return (
    <ChakraProvider theme={theme}>
      <I18nProvider>{children}</I18nProvider>
    </ChakraProvider>
  );
}
